module.exports = __webpack_public_path__ + "img/1515590219.64bca429.jpg";